export default function LinkedButton({ label, className, onClick, disabled }) {
  return (
    <>
      <button
        className={`bg-transparent text-[#087E9E] border-none px-2 py-1 text-base cursor-pointer leading-6 font-medium hover:underline ${className} ${disabled ? "pointer-events-none !text-gray-300" : ""}`}
        type="button"
        onClick={onClick}
        disabled={disabled}
      >
        {label}
      </button>
    </>
  );
}
